import { SecurityAccessFeaturesEnum } from 'bff';
import { useUserContext } from 'providers/managers/user-context-manager/user-context-manager';
import { PropsWithChildren } from 'react';

interface AllowForProps {
  features?: SecurityAccessFeaturesEnum[];
}

export const AllowFor = ({ features, children }: PropsWithChildren<AllowForProps>) => {
  const userContext = useUserContext();
  const hasPermission = userContext.canAccessAll(features ?? []);

  if (hasPermission) {
    return <>{children}</>;
  }

  return null;
};
